import { of } from 'rxjs';
import { CmsComponentData, CmsLinkComponent } from '@boels/models';

export const primaryButtonMockData: CmsComponentData<CmsLinkComponent> = {
  data$: of({
    linkName: 'Primary button text',
    target: true,
    url: 'www.google.com',
  }),
};
